import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import './portcoTable.css';
import "../../common/css/protagonistMUIDatatable.css";
import "../../common/css/icons.css";
import { TableCell, IconButton, Snackbar } from '@mui/material';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { DeletePortfolioCompany } from '../../common/api/PortcoAPIHelper';

const PortcoTable = ({ data, onEdit, onDelete }) => {
  console.log(data);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleDelete = async (portcoId) => {
    const confirmed = window.confirm('Are you sure you want to delete the portfolio company?');
    if (confirmed) {
      const response = await DeletePortfolioCompany(portcoId);
      if (response && response.status === 200) {
        setSnackbarMessage(`Successfully deleted portfolio company with ID ${portcoId}`);
        onDelete();
      } else {
        console.error('Error:', response.status, response.statusText);
        setSnackbarMessage(`Failed to delete portfolio company with ID ${portcoId}`);
      }
      setSnackbarOpen(true);
    }
  };

  const handleEdit = (portcoId) => {
    const portco = data.find(portco => portco.portco_id === portcoId);  // Fetch the whole fund object
    onEdit(portco); // Pass the fund object to the onEdit callback
};

  const customPortcoIdRender = (value, tableMeta, updateValue) => {
    const portcoId = value;
    const handleDeleteClick = () => handleDelete(portcoId);
    const handleEditClick = () => handleEdit(portcoId, tableMeta.rowData); // Pass the row data when the edit button is clicked

    return (
      <div>
        <IconButton onClick={handleEditClick}>
          <FontAwesomeIcon icon={faPen} className="ra__protMUIDatatable_icon" /> {/* Edit icon */}
        </IconButton>
        <IconButton onClick={handleDeleteClick}>
          <FontAwesomeIcon icon={faTrashAlt} className="ra__protMUIDatatable_icon" />
        </IconButton>
      </div>
    );
  };

  const customNameRender = (value, tableMeta) => {
    const portcoId = tableMeta.rowData[0];
    const companyName = value;
    
    return (
      <Link to={`/portfolio-company/${portcoId}`}>
        {companyName}
      </Link>
    );
  };

  const customCheckRender = (value) => {
    if (value) {
      return (
        <TableCell className="check-column">
          <i className="fa-sharp fa-solid fa-square-check fa-lg ra__protMUIDatatable_checkmark"></i>
        </TableCell>
      );
    } else {
      return (
        <TableCell className="cross-column">
          <i className="fa-sharp fa-solid fa-circle-xmark fa-lg ra__protMUIDatatable_cross"></i>
        </TableCell>
      );
    }
  };

  const customWebsiteUrlRender = (value) => {
    const websiteUrl = value;
    return (
      <a href={websiteUrl} target="_blank" rel="noopener noreferrer">
        {websiteUrl}
      </a>
    );
  };
  

  if (!data) {
    return <div>No data available.</div>;
  }

  const columns = [
    { 
      name: 'portco_id', 
      label: 'Edit / Delete',
      options: {
        customBodyRender: customPortcoIdRender,
      },
    },
    { 
      name: 'company_name', 
      label: 'Company Name',
      options: {
        customBodyRender: customNameRender,
        sort: true,
      },
    },
    { name: 'company_legal_name', label: 'Legal Name' },
    { name: 'pitchbook_id', label: 'Pitchbook ID' },
    { 
      name: 'website_url', 
      label: 'Website URL',
      options: {
        customBodyRender: customWebsiteUrlRender,
      },
    },
    { name: 'website_blurb', label: 'Website Blurb' },
    { 
      name: 'show_on_public_website', 
      label: 'Visible on Public Website',
      options: {
        customBodyRender: customCheckRender,
      },
    },
    { 
      name: 'highlight_on_public_website', 
      label: 'Highlight on Public Website',
      options: {
        customBodyRender: customCheckRender,
      },
    },
  ];

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'standard',
    serverSide: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15],
    selectableRows: 'none',
    expandableRows: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    sortable: true,
    sortOrder: {
      name: 'company_name',
      direction: 'asc'
    },
    customToolbarSelect: () => {},
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'medium',
      };
    },
    textLabels: {
      body: {
        noMatch: 'Sorry, no matching records found',
      },
    },
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMessage('');
  };

  return (
    <div>
      <MUIDataTable
        title={'Portfolio Companies'}
        data={data}
        columns={columns}
        options={options}
        className="protMUIDatatable"
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        className={snackbarMessage.includes('Successfully') ? 'ra__protMUIDatatable_snackbar' : 'ra__protMUIDatatable_snackbar error'}
      />
    </div>
  );
};

export default PortcoTable;
